import { useMediaQuery } from '@mantine/hooks'

/** Matches layout SCSS breakpoint: desktop at 960px+ (mobile max-width 959px). */
export const CAUSE_DASHBOARD_DESKTOP_MIN_WIDTH_MEDIA = '(min-width: 960px)' as const

export function useIsDesktopLayout() {
  return useMediaQuery(CAUSE_DASHBOARD_DESKTOP_MIN_WIDTH_MEDIA, true)
}
